import React from 'react';
import { X, CreditCard, Shield } from 'lucide-react';
import { MembershipTier } from '../../types';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedTier: MembershipTier;
  price: number;
  onConfirm: () => void;
  loading?: boolean;
}

export function UpgradeModal({
  isOpen,
  onClose,
  selectedTier,
  price,
  onConfirm,
  loading = false
}: UpgradeModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-bw-surface rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <h3 className="text-xl font-semibold text-bw-ink">Upgrade to {selectedTier}</h3>
            <button
              onClick={onClose}
              className="text-bw-muted hover:text-bw-muted"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="space-y-6">
            <div className="flex items-center justify-between pb-4 border-b">
              <div>
                <p className="text-sm text-bw-muted">Monthly Subscription</p>
                <p className="text-2xl font-bold text-bw-ink">${price}</p>
              </div>
              <Shield className="h-8 w-8 text-bw-primary" />
            </div>

            <div className="space-y-4">
              <p className="text-sm text-bw-muted">
                Your card will be charged ${price} monthly. You can cancel or change your subscription at any time.
              </p>

              <div className="bg-bw-primary-tint p-4 rounded-lg">
                <p className="text-sm text-bw-primary">
                  Your new subscription will start immediately after payment confirmation.
                </p>
              </div>
            </div>

            <button
              onClick={onConfirm}
              disabled={loading}
              className="w-full flex items-center justify-center px-4 py-3 rounded-md text-white bg-servet-red hover:bg-servet-red/90 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                  Processing...
                </div>
              ) : (
                <>
                  <CreditCard className="h-5 w-5 mr-2" />
                  Confirm Upgrade
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}